module.exports = __webpack_public_path__ + "static/0-2e72c07e61407e2928cb4c56afe9a2ef.png";